export default async function InsertPlotSequence(sendForm) {
    let url = window.RealestateService+  `/api/ProjectPlotDetails/InsertPlotSequence`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let data ={}
    let response  = await fetch(url, {
        method:"POST",
        headers:head,
        body:JSON.stringify(sendForm)
    }).then(res=>res.json()).then(data)

    return response
}